import React, { useState } from "react";
import "../../style/ForgotPassword.css"; // Ensure corresponding CSS file exists
import { FaEnvelope, FaUser } from "react-icons/fa";
import logo from "../assets/logo.png";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_SOURCE;

  const [formData, setFormData] = useState({
    username: "",
    email: "",
  });

  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const isValidUBEmail = (email) => {
    return email.endsWith("@buffalo.edu"); // ✅ Validate UB email
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (!isValidUBEmail(formData.email)) {
      setError("Only UB email addresses (@buffalo.edu) are allowed.");
      return;
    }

    setLoading(true);

    console.log("Sending data:", JSON.stringify(formData));

    try {
      const response = await fetch(`${API_BASE_URL}/backend/api/Settings/request_forgot_password.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      setLoading(false);

      if (result.status === "success") {
        setMessage("Password reset link sent to your email.");
      } else {
        setError(result.message);
      }
    } catch (error) {
      console.error("Forgot Password Error:", error);
      setError("An error occurred. Please try again.");
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-box">
        {/* ✅ Match logo to Figma */}
        <div className="logo-container">
          <img src={logo} alt="LockedIn Logo" className="logo" />
        </div>

        <h2>Forgot Password?</h2>
        <p>Enter your username and UB email to receive a password reset link.</p>

        <form onSubmit={handleSubmit} className="forgot-password-form">
          <div className="input-box">
            <input
              type="text"
              placeholder="Username"
              name="username"
              onChange={handleChange}
              required
            />
            <FaUser className="icon" />
          </div>
          <div className="input-box">
            <input
              type="email"
              placeholder="UB Email (e.g., example@buffalo.edu)"
              name="email"
              onChange={handleChange}
              required
            />
            <FaEnvelope className="icon" />
          </div>
          {error && <p className="error">{error}</p>}
          {message && <p className="success">{message}</p>}

          <button type="submit" className="forgot-password-btn" disabled={loading}>
            {loading ? "Sending..." : "Send Reset Link"}
          </button>
        </form>

        <div className="back-to-login">
          <p>
            Remembered your password?{" "}
            <span onClick={() => navigate("/login")} className="login-text">
              Login
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;